import * as React from 'react';
import strings from 'owa-strings/owa-mail-strings';
import { DefaultButton, PrimaryButton } from 'office-ui-fabric-react/lib/Button';
import { observer } from 'mobx-react';

const styles = require('./ActionButtons.scss');

export interface ActionButtonsProps {
    onApplyClicked: () => void;
    onCancelClicked: () => void;
    isApplyDisabled: boolean;
}

@observer
export default class ActionButtons extends React.Component<ActionButtonsProps, {}> {
    render() {
        return (
            <div className={styles.container}>
                <div className={styles.buttonContainer}>
                    <PrimaryButton
                        className={styles.button}
                        disabled={this.props.isApplyDisabled}
                        ariaLabel={'Apply'}
                        onClick={() => {
                            this.props.onApplyClicked();
                        }}>
                        {'Apply'} {/* TODO VSO 37144: localize */}
                    </PrimaryButton>

                    <span className={styles.cancelButtonContainer}>
                        <DefaultButton
                            className={styles.button}
                            ariaLabel={strings.CancelText}
                            onClick={this.props.onCancelClicked}>
                            {strings.CancelText}
                        </DefaultButton>
                    </span>
                </div>
            </div>
        );
    }
}
